import { ID } from '@ianesthesie-kit/services';
import { PhysicalExamination } from './physicalExamination.model';
import { PatchableMedicalService } from '../patchableMedical.service';

export class PhysicalExaminationService extends PatchableMedicalService<PhysicalExamination> {
  private static INSTANCE_BY_ID: PhysicalExaminationService;

  private constructor(patientId: string) {
    super('/physical-examination', patientId);
  }

  public static getInstance(patientId: ID): PhysicalExaminationService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new PhysicalExaminationService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }
  public static getNormalValues(): Partial<PhysicalExamination> {
    return {
      cardiovascularCodes: ['METS_OVER_4'],
      auscultationCodes: ['NORMAL'],
      respiratoryCodes: ['NO_DYSPNEA']
    };
  }
}
